import { INITIALIZE_APP_PROPS, type InitializeAppPropsAction } from '../../actions/app';
import {
	VELOCITY_DATA_FETCH_SUCCESS,
	type VelocityDataFetchSuccessAction,
	VELOCITY_DATA_FETCH_FAILURE,
} from '../../actions/velocity-data-fetch';
import type { AppState } from './types';

export type Action = InitializeAppPropsAction | VelocityDataFetchSuccessAction;

const defaultState: AppState = {
	baseUrl: '',
	boardId: 0,
	isFirstDataLoaded: false,
	isError: false,
	fetchError: null,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AppState = defaultState, action: Action): AppState => {
	switch (action.type) {
		case INITIALIZE_APP_PROPS: {
			const { baseUrl, boardId } = action.payload;

			return {
				...state,
				baseUrl,
				boardId,
			};
		}
		case VELOCITY_DATA_FETCH_SUCCESS:
			return {
				...state,
				isFirstDataLoaded: true,
			};
		// @ts-expect-error - TS2678 - Type '"state.actions.velocity-data-fetch.VELOCITY_DATA_FETCH_FAILURE"' is not comparable to type '"state.actions.app.INITIALIZE_APP_PROPS" | "state.actions.velocity-data-fetch.VELOCITY_DATA_FETCH_SUCCESS"'.
		case VELOCITY_DATA_FETCH_FAILURE:
			return {
				...state,
				// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
				fetchError: action.payload,
				isError: true,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
